import React from "react";
import { makeStyles, tokens } from "@fluentui/react-components";
import { CallTimer } from "./CallTimer";
import { ActiveCallDetails } from "./ActiveCallDetails";
import { MEDIA_MTYPE } from "../../services/webex/contactcenter/models/IRoutingMessage";
const styles = makeStyles({
    container: {
        display: "flex",
        gap: "1rem",
        flexDirection: "row",
        width: "100%",
        alignItems: "stretch",
        boxSizing: "border-box",
        backgroundColor: tokens.colorBrandBackground2,
        padding: "15px 15px",
        verticalAlign: "middle",
        borderRadius: "6px",
        border: `1px solid ${tokens.colorBrandForegroundInverted}`,
    },
    root: {
        padding: "15px",
        boxSizing: "border-box",
        width: "100%",
    },
    timerContainter: {
        display: "flex",
        flexDirection: "column",
        gap: "0",
        alignItems: "center",
        verticalAlign: "middle",
    },
    timer: {
        // backgroundColor: tokens.colorBrandBackground,
        borderRadius: "4px",
        // padding: "10px 10px",
    },
    timerDescription: {
        fontSize: "12px",
        color: tokens.colorBrandForeground2,
    },
    disconnected: {
        fontSize: "12px",
        color: "#FFFFFF",
        backgroundColor: tokens.colorStatusDangerBackground3Hover,
        padding: "1px 8px",
        marginTop: "5px",
        borderRadius: "8px"
    },
});
export const HeldCallItem = (props) => {
    const classes = styles();
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.container },
            React.createElement("div", { className: classes.timerContainter },
                React.createElement(CallTimer, { timeOffset: props.timeOffset, callState: props.callState, startTime: props.startTime, className: classes.timer }),
                React.createElement("div", { className: classes.timerDescription }, props.callType === MEDIA_MTYPE.MAINCALL ? "Main Call" : "Consult Call"),
                props.callState === "ended" && (React.createElement("div", { className: classes.disconnected }, "ENDED"))),
            props.callType === MEDIA_MTYPE.MAINCALL ? (React.createElement(ActiveCallDetails, { hasCustomerLeft: props.callState === "ended", isHeldCallSummary: true, callDirection: props.callDirection, callerId: props.callerId, dynamicsCustomerAccounts: props.dynamicsCustomerAccounts, customerDescription: props.customerDescription, customerBranch: props.customerBranch, customerDepartment: props.customerDepartment })) : (React.createElement(ActiveCallDetails, { isHeldCallSummary: true, callDirection: props.callDirection, callerId: props.callerId, toDescription: props.toDescription, isConsultLeg: true })))));
};
